import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SmsCodeRetry({
  retryCode
}) {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx("a", {
        onClick: retryCode,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.codeForm.newCode"
        })
      })
    })
  });
}